export const WIDTH_PDF_PORTRAIT = 757
export const PADDING_PDF = 50
export const WIDTH_PDF_PORTRAIT_WITHOUT_PADDING =
  WIDTH_PDF_PORTRAIT - 2 * PADDING_PDF
export const HEIGHT_PDF_PORTRAIT_WITHOUT_PADDING = 850
